export default __webpack_public_path__ + "static/media/meet-minerva-screen-2.d90f189f.jpg";